module.exports = __webpack_public_path__ + "img/w3_percent_white.fddac4b0.png";